import { IMG } from "@/lib/content";
import { Reveal } from "@/components/site/Reveal";
import { Overline } from "@/components/site/primitives";
import ConceptTag from "@/components/site/ConceptTag";
import PartnershipForm from "@/components/site/PartnershipForm";

export default function DevelopmentSection() {
  return (
    <section id="partner" className="scroll-mt-24 border-t border-white/10 bg-rp-surface" data-testid="development-section">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline>The Road Ahead</Overline>
              <h2 className="mt-5 font-display text-4xl font-light uppercase leading-[0.95] tracking-tight md:text-5xl">
                The Journey<br />Starts Here.
              </h2>
              <p className="mt-6 max-w-md text-base leading-relaxed text-white/55">
                RestPower is currently in development. We're building the foundation for our first
                destination and exploring the partnerships, locations, and infrastructure required to
                bring the RestPower experience to life.
              </p>
            </Reveal>

            <Reveal delay={0.1} className="mt-8">
              <div className="relative overflow-hidden rounded-2xl border border-white/10">
                <img src={IMG.developmentAerial} alt="RestPower site concept, aerial view" loading="lazy"
                  className="h-56 w-full object-cover md:h-64" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <ConceptTag className="absolute left-4 top-4" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.05} className="rounded-3xl border border-white/10 bg-rp-card p-7 md:p-10">
              <h3 className="font-display text-2xl font-medium tracking-tight text-white">Partner with RestPower</h3>
              <p className="mt-2 text-sm text-white/50">
                Real estate, EV infrastructure, energy, hospitality, fleet, brand, or investment — we'd love to hear from you.
              </p>
              <div className="mt-8">
                <PartnershipForm />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
